// ALIGN 브랜드 마크 — 궤도(원)를 가로지르는 선, 그 교차점에서 터지는 빛(정렬의 순간).
// (구 점·선 방사형 패턴 대체 — "여러 점술이 겹쳐 하나로 정렬된다"는 개념을 원·사선·글로우로 재형상화)
import { useId } from "react";

export function BrandMark({ size = 26 }: { size?: number }) {
  const gid = useId().replace(/:/g, "");
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" style={{ flex: "none" }}>
      <defs>
        <radialGradient id={gid} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="var(--emph)" stopOpacity={1} />
          <stop offset="35%" stopColor="var(--emph)" stopOpacity={0.5} />
          <stop offset="100%" stopColor="var(--emph)" stopOpacity={0} />
        </radialGradient>
      </defs>
      <circle cx={20} cy={20} r={13} fill="none" stroke="var(--steel)" strokeWidth={1} opacity={0.85} />
      <line x1={9} y1={35.5} x2={31} y2={4.5} stroke="var(--steel)" strokeWidth={1.2} strokeLinecap="round" />
      <circle cx={20} cy={20} r={5} fill={`url(#${gid})`} />
      <circle cx={20} cy={20} r={1.6} fill="var(--emph)" />
    </svg>
  );
}
